<div class="d-flex flex-row">
    <div class="check-icon icon-override size-32" style="margin-right: 16px; margin-top: 2px;"></div>
    <div class="d-flex flex-column">
        <div class="snack-title" *ngIf="data && data.title">{{data?.title | translate}}</div>
        <div class="snack-text" *ngIf="data && data.text">{{data?.text | translate}}</div>
    </div>
</div>